/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { SecurityHelper } from 'sarsaparilla';
import axios from 'axios';

const BuyNowContext = createContext({
    showBuyNow: false,
    canBuyNow: false,
    reservationId: undefined,
    setShowBuyNow: () => {},
    setReservationId: () => {},
});

export function BuyNowProvider({ children }) {
    const [showBuyNow, setShowBuyNow] = useState(false);
    const [canBuyNow, setCanBuyNow] = useState(false);
    const [reservationId, setReservationId] = useState(undefined);

    useEffect(() => {
        if (!showBuyNow) return;
        axios
            .get(`${process.env.API}/cart/buy-now`, {
                headers: { Authorization: SecurityHelper.getAuthHeader() },
            })
            .then((response) => setCanBuyNow(response.data.can_buy_now))
            .catch(() => setCanBuyNow(false));
    }, [showBuyNow]);

    const value = useMemo(
        () => ({
            showBuyNow,
            canBuyNow,
            reservationId,
            setShowBuyNow,
            setReservationId,
        }),
        [showBuyNow, canBuyNow, reservationId]
    );

    return <BuyNowContext.Provider value={value}>{children}</BuyNowContext.Provider>;
}

export function useBuyNowContext() {
    return useContext(BuyNowContext);
}

export function useBuyNowRegister(showBuyNow, reservationId) {
    const { setShowBuyNow, setReservationId } = useContext(BuyNowContext);
    useEffect(() => {
        setShowBuyNow(showBuyNow);
        setReservationId(reservationId);
        return () => {
            setShowBuyNow(false);
            setReservationId(undefined);
        };
    }, [showBuyNow, reservationId, setShowBuyNow, setReservationId]);
}
